var map = {
	"./1.svg": 65583,
	"./10.svg": 88886,
	"./11.svg": 14816,
	"./12.svg": 78069,
	"./13.svg": 70571,
	"./14.svg": 26452,
	"./15.svg": 78548,
	"./16.svg": 50806,
	"./17.svg": 31907,
	"./18.svg": 80009,
	"./19.svg": 28593,
	"./2.svg": 70305,
	"./20.svg": 62717,
	"./21.svg": 57614,
	"./22.svg": 78342,
	"./23.svg": 94503,
	"./24.svg": 31438,
	"./25.svg": 63889,
	"./26.svg": 68532,
	"./27.svg": 65332,
	"./28.svg": 9055,
	"./29.svg": 64252,
	"./3.svg": 72730,
	"./30.svg": 27046,
	"./31.svg": 88765,
	"./32.svg": 29196,
	"./33.svg": 90903,
	"./34.svg": 95212,
	"./35.svg": 48970,
	"./36.svg": 17469,
	"./37.svg": 26757,
	"./38.svg": 49212,
	"./39.svg": 86769,
	"./4.svg": 20885,
	"./40.svg": 33230,
	"./41.svg": 34511,
	"./42.svg": 57996,
	"./43.svg": 19332,
	"./44.svg": 76403,
	"./45.svg": 14393,
	"./5.svg": 62684,
	"./6.svg": 37304,
	"./7.svg": 82433,
	"./8.svg": 64208,
	"./9.svg": 61014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5804;